// extracted by mini-css-extract-plugin
export var cell = "_59-4";
export var headerCell = "_59-2";
export var rowHeader = "_59-3";
export var table = "_59-1";
export var tableContainer = "_59-0";